import { render, staticRenderFns } from "./HeaderWaterQuality.vue?vue&type=template&id=c2bba964&"
import script from "./HeaderWaterQuality.vue?vue&type=script&lang=js&"
export * from "./HeaderWaterQuality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports